export default __webpack_public_path__ + "static/media/logo138x75black.440c1100.png";